import styled from 'astroturf/react'
import { BareButton } from '@calendly/ui/components/bare-button'
const colorTextStandard = 'var(--colorTextStandard, var(--coreColorNeutral900))'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'
const colorStrokeFocus = 'var(--colorStrokeFocus, var(--coreColorBlue600))'
const colorSurfaceAction = 'var(--colorSurfaceAction, var(--coreColorBlue600))'
const colorTextInverseStandard = 'var(--colorTextInverseStandard, var(--coreColorNeutral0))'
const colorTextAction = 'var(--colorTextAction, var(--coreColorBlue600))'
const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'
const fontWeightBold = 'var(--fontWeightBold, 700)'
import { BodyText, HeadingText } from '@calendly/ui/components/typography'
import _Container from "styles-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/signup/styles.js?styleId=Container";
import _Subtext from "styles-Subtext.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/signup/styles.js?styleId=Subtext";
import _Title from "styles-Title.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/signup/styles.js?styleId=Title";
import _Form from "styles-Form.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/signup/styles.js?styleId=Form";
import _Input from "styles-Input.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/signup/styles.js?styleId=Input";
import _Submit from "styles-Submit.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/signup/styles.js?styleId=Submit";
import _StyledText from "styles-StyledText.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/signup/styles.js?styleId=StyledText";
import _StandardSignupForm from "styles-StandardSignupForm.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/signup/styles.js?styleId=StandardSignupForm";
import _StandardSubmitButton from "styles-StandardSubmitButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/signup/styles.js?styleId=StandardSubmitButton";
import _StandardEmailInput from "styles-StandardEmailInput.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/signup/styles.js?styleId=StandardEmailInput";


const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container
})

const Subtext = /*#__PURE__*/styled('div', null, {
  displayName: "Subtext",
  styles: _Subtext,
  attrs: ({
    children
  }) => ({
    children: <BodyText>{children}</BodyText>
  })
})

const Title = /*#__PURE__*/styled('div', null, {
  displayName: "Title",
  styles: _Title,
  attrs: ({
    children
  }) => ({
    children: <HeadingText level={2} size="small">{children}</HeadingText>
  })
})

const Form = /*#__PURE__*/styled('form', null, {
  displayName: "Form",
  styles: _Form
})

const Input = /*#__PURE__*/styled('input', null, {
  displayName: "Input",
  styles: _Input
})

const Submit = /*#__PURE__*/styled(BareButton, null, {
  displayName: "Submit",
  styles: _Submit
})

const StyledText = /*#__PURE__*/styled('span', null, {
  displayName: "StyledText",
  styles: _StyledText
})

const StandardSignupForm = /*#__PURE__*/styled(Form, null, {
  displayName: "StandardSignupForm",
  styles: _StandardSignupForm
})

const StandardSubmitButton = /*#__PURE__*/styled(Submit, null, {
  displayName: "StandardSubmitButton",
  styles: _StandardSubmitButton
})

const StandardEmailInput = /*#__PURE__*/styled(Input, null, {
  displayName: "StandardEmailInput",
  styles: _StandardEmailInput
})

export {
  Container,
  Form,
  Input,
  StandardEmailInput,
  StandardSignupForm,
  StandardSubmitButton,
  StyledText,
  Submit,
  Subtext,
  Title,
}
